import React from "react";
import { Box } from "@mui/material";
import { showcaseContainerStyles, leftHalfStyles, rightHalfStyles, topHalfStyles, bottomHalfStyles, bottomLeftStyles, bottomRightStyles } from "./CategoryShowcase/CategoryShowcaseStyles";
import { CategoryImage, ImageWithOverlay } from "./CategoryShowcase/ImageWithOverlay";

interface CategoryShowcaseProps {
  mainImage: CategoryImage;
  topImage: CategoryImage;
  bottomLeftImage: CategoryImage;
  bottomRightImage: CategoryImage;
  
}

const CategoryShowcase: React.FC<CategoryShowcaseProps> = ({
  mainImage,
  topImage,
  bottomLeftImage,
  bottomRightImage,
}) => {
  return (
    <Box sx={showcaseContainerStyles}>
      <Box sx={leftHalfStyles}>
        <ImageWithOverlay image={mainImage} section="main" />
      </Box>

      <Box sx={rightHalfStyles}>
        <Box sx={topHalfStyles}>
          <ImageWithOverlay image={topImage} section="top" />
        </Box>

        <Box sx={bottomHalfStyles}>
          <Box sx={bottomLeftStyles}>
            <ImageWithOverlay image={bottomLeftImage} section="bottomLeft" />
          </Box>
          <Box sx={bottomRightStyles}>
            <ImageWithOverlay image={bottomRightImage} section="bottomRight" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CategoryShowcase;














